import React, { useCallback, useEffect, useState } from "react";
import {
  Row,
  Col,
  Space,
  Button,
  Breadcrumb,
  Form,
  theme,
  Divider,
  Input,
  Select,
} from "antd";
import _ from "lodash";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import useAuth from "../../../lib/hooks/useAuth";
import useCancelModal from "../../../lib/hooks/useCancelModal";
import { routes } from "../../../routes";
import { SUCCESS_CODE, ERR_0022 } from "../../../lib/const";
import Heading from "../../../components/common/heading";
import FailModal from "../../../components/modal/failModal";
import SuccessModal from "../../../components/modal/successModal";
import WithSidebar from "../../../templates/withSidebar";
import {
  getListDepartments,
  // getListIndicators,
  getListDivisions,
  createIndicator,
  getIndicatorByYearlyPlan,
} from "../../../services/progressPerformance";

const { useToken } = theme;
const { Option } = Select;

export const AddIndicator = () => {
  const { token } = useToken();
  const { auth } = useAuth();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { setOpenCancelModal, setPreviousPage } = useCancelModal();
  const [dropDownDepartment, setDropDownDepartment] = useState([]);
  const [dropDownDivision, setDropDownDivision] = useState([]);
  const [listIndicators, setListIndicators] = useState([]);
  const [departmentId, setDepartmentId] = useState();
  const [divisionId, setDivisionId] = useState();
  const [successModal, setSuccessModal] = useState(false);
  const [failModal, setFailModal] = useState(false);
  const [year, setYear] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const years = moment().add(1, "years").format("YYYY");
  const yearArray = [
    parseInt(years),
    parseInt(years - 1),
    parseInt(years - 2),
    parseInt(years - 3),
    parseInt(years - 4),
  ];

  const getPermission =
    auth?.user?.permissions &&
    _.get(
      auth?.user?.permissions.find(
        (item) => item.permissionName === "Application field"
      ),
      "permissionList",
      []
    ).find(
      (item) =>
        item.pageName === "รายงานผลตัวชี้วัด" &&
        _.get(item, "customPermission['Access all years of budget']", false) ===
          true
    );

  // const [indicatorId, setIndicatorId] = useState();
  const months = [
    {
      value: 10,
      name: "ตุลาคม",
    },
    {
      value: 11,
      name: "พฤศจิกายน",
    },
    {
      value: 12,
      name: "ธันวาคม",
    },
    {
      value: 1,
      name: "มกราคม",
    },
    {
      value: 2,
      name: "กุมภาพันธ์",
    },
    {
      value: 3,
      name: "มีนาคม",
    },
    {
      value: 4,
      name: "เมษายน",
    },
    {
      value: 5,
      name: "พฤษภาคม",
    },
    {
      value: 6,
      name: "มิถุนายน",
    },
    {
      value: 7,
      name: "กรกฎาคม",
    },
    {
      value: 8,
      name: "สิงหาคม",
    },
    {
      value: 9,
      name: "กันยายน",
    },
  ];

  const handleChange = (value, key) => {
    setDepartmentId(value);
    form.setFields([
      {
        name: "name",
        value: undefined,
      },
      {
        name: "divisionId",
        value: undefined,
      },
    ]);
  };

  const onFinish = async (values) => {
    const year = Number(values.yearOfBudget) + 543;

    const request = {
      indicatorId: values.indicatorId,
      departmentId: values.departmentId,
      divisionId: values.divisionId,
      monthOfBudget: values.monthOfBudget,
      yearOfBudget: values.yearOfBudget,
      monthlyValue: values.monthlyIndicator,
      quarterlyForecast: values.quarterlyForecast,
      annualForecast: values.annualForecast,
      status: "true",
    };

    const res = await createIndicator(request);
    if (res.data.code === SUCCESS_CODE) {
      setSuccessModal(true);
      setTimeout(() => {
        navigate(routes.progress_tab_indicator);
        setSuccessModal(false);
      }, 2000);
    } else {
      if (res.data.code === ERR_0022) {
        setFailModal(true);
        setErrorMessage("ตัวชี้วัดดังกล่าวมีอยู่ในระบบเรียบร้อยแล้ว");
      } else {
        setErrorMessage("");
        setFailModal(true);
        setTimeout(() => {
          setFailModal(false);
        }, 2000);
      }
    }
  };

  const fetchListDepartments = useCallback(async () => {
    try {
      const res = await getListDepartments();

      if (res.data.code === SUCCESS_CODE) {
        let result_data = res.data.objectValue;
        setDropDownDepartment(result_data);
      }
    } catch (error) {}
  }, [dropDownDepartment]);

  // const fetchListIndicators = useCallback(async () => {
  //   try {
  //     const res = await getListIndicators(departmentId);

  //     if (res.data.code === SUCCESS_CODE) {
  //       let result_data = res.data.objectValue;
  //       setListIndicators(result_data);
  //     }
  //   } catch (error) {}
  // }, [listIndicators, departmentId]);

  const fetchListDivisions = useCallback(async () => {
    try {
      const res = await getListDivisions(departmentId);

      if (res.data.code === SUCCESS_CODE) {
        let result_data = res.data.objectValue;
        setDropDownDivision(result_data);
      }
    } catch (error) {}
  }, [departmentId]);

  const fetchIndicatorByYearlyPlan = useCallback(async () => {
    try {
      const request = {
        departmentId: form.getFieldValue().departmentId
          ? form.getFieldValue().departmentId
          : "",
        divisionId: form.getFieldValue().divisionId
          ? form.getFieldValue().divisionId
          : "",
        yearOfBudget: form.getFieldValue().yearOfBudget
          ? form.getFieldValue().yearOfBudget
          : "",
      };
      const res = await getIndicatorByYearlyPlan(request);

      if (res.data.code === SUCCESS_CODE) {
        let result_data = res.data.objectValue;
        setListIndicators(result_data);
        form.setFields([
          {
            name: "indicatorId",
            value: undefined,
          },
        ]);
      }
    } catch (error) {}
  }, [departmentId, divisionId, year]);

  useEffect(() => {
    fetchIndicatorByYearlyPlan();
  }, [departmentId, divisionId, year]);

  useEffect(() => {
    fetchListDepartments();
  }, []);

  // useEffect(() => {
  //   if (departmentId) {
  //     fetchListIndicators();
  //   }
  // }, [departmentId]);

  useEffect(() => {
    if (departmentId) {
      fetchListDivisions();
    }
  }, [departmentId]);

  useEffect(() => {
    if (getPermission) {
      form.setFields([
        {
          name: "yearOfBudget",
          value: null,
        },
      ]);
    } else {
      const currentMonth = new Date().getMonth() + 1;
      const currentYear = new Date().getFullYear() + 543;
      form.setFields([
        {
          name: "yearOfBudget",
          value: currentMonth >= 10 ? currentYear + 1 : currentYear,
        },
      ]);
    }
  }, [getPermission]);

  return (
    <WithSidebar>
      <div>
        <Row gutter={[24, 24]} style={{ marginTop: 15 }}>
          <Col span={24}>
            <div className="flex items-center">
              <Space size={12}>
                <Button
                  type="link"
                  onClick={() => {
                    setOpenCancelModal(true);
                    setPreviousPage(routes.progress_tab_indicator);
                  }}
                  style={{ padding: 0 }}
                >
                  <ArrowLeftOutlined style={{ color: "#000", fontSize: 16 }} />
                </Button>
                <Heading text={"เพิ่มข้อมูล"} size={4} style={{ margin: 0 }} />
              </Space>
            </div>
            <Breadcrumb
              style={{ paddingTop: 10 }}
              items={[
                {
                  title: "คลังข้อมูลตัวชี้วัด",
                },
                {
                  title: <span className="pr_green">เพิ่มข้อมูล</span>,
                },
              ]}
            />
          </Col>

          <Col span={24}>
            <Form
              form={form}
              onFinish={onFinish}
              layout="vertical"
              autoComplete="off"
              style={{ width: "100%", padding: "0 30px" }}
            >
              <Row gutter={[24, 16]} style={{ marginBottom: 10 }}>
                <Col span={24} align="right">
                  <Space>
                    <Button
                      onClick={() => {
                        setOpenCancelModal(true);
                        setPreviousPage(routes.progress_tab_indicator);
                      }}
                    >
                      ยกเลิก
                    </Button>
                    <Button type="primary" htmlType="submit">
                      บันทึก
                    </Button>
                  </Space>
                </Col>
              </Row>

              <Row gutter={[16, 8]} className="card">
                <Col span={24}>
                  <Row gutter={16}>
                    <Col span={18}>
                      <Heading
                        text={"ข้อมูลตัวชี้วัด"}
                        size={4}
                        style={{ margin: 0, color: token.thPrimary }}
                      />
                    </Col>
                    {/* <Col span={6}>
                      <Form.Item label="" name={"departmentId"}>
                        <Select
                          allowClear
                          style={{
                            width: "100%",
                          }}
                          placeholder="กรุณาเลือก"
                          onChange={handleChange}
                        >
                          {dropDownDepartment.map((option, i) => (
                            <Option key={i} value={option.departmentId}>
                              {option.departmentNameTh}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col> */}
                  </Row>
                  <Divider />
                </Col>

                <Col span={16}>
                  <Form.Item
                    label="ปีงบประมาณ"
                    name={"yearOfBudget"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    {getPermission ? (
                      <Select
                        allowClear
                        style={{
                          width: "100%",
                        }}
                        placeholder="กรุณาเลือก"
                        maxTagCount={"responsive"}
                        onChange={() => {
                          let arr = form.getFieldValue().yearOfBudget;
                          setYear(arr);
                        }}
                        value={year}
                      >
                        {yearArray.map((item) => (
                          <Option value={parseInt(item) + 543}>
                            {parseInt(item) + 543}
                          </Option>
                        ))}
                      </Select>
                    ) : (
                      <Input placeholder="ปีงบประมาณ" disabled />
                    )}
                  </Form.Item>
                </Col>
                <Col span={16}>
                  <Form.Item
                    label="เดือนงบประมาณ"
                    name={"monthOfBudget"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Select
                      allowClear
                      style={{
                        width: "100%",
                      }}
                      placeholder="กรุณาเลือก"
                      maxTagCount={"responsive"}
                      onChange={() => {
                        let arr = form.getFieldsValue().monthOfBudget;
                        const currentYear = new Date().getFullYear() + 543;
                        let arrYear = form.getFieldsValue().yearOfBudget;

                        // if (!getPermission) {
                        //   if (arr >= 10) {
                        //     setYear(currentYear + 1);
                        //     form.setFields([
                        //       {
                        //         name: "yearOfBudget",
                        //         value: currentYear + 1,
                        //       },
                        //     ]);
                        //   } else {
                        //     setYear(currentYear);
                        //     form.setFields([
                        //       {
                        //         name: "yearOfBudget",
                        //         value: currentYear,
                        //       },
                        //     ]);
                        //   }
                        // }
                      }}
                    >
                      {months.map((m) => (
                        <Option value={m.value}>{m.name}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={16}>
                  <Form.Item
                    label="ฝ่าย"
                    name={"departmentId"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Select
                      allowClear
                      style={{
                        width: "100%",
                      }}
                      placeholder="กรุณาเลือก"
                      onChange={handleChange}
                    >
                      {dropDownDepartment.map((option, i) => (
                        <Option key={i} value={option.departmentId}>
                          {option.departmentNameTh}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={16}>
                  <Form.Item
                    label="กอง"
                    name={"divisionId"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Select
                      allowClear
                      style={{
                        width: "100%",
                      }}
                      placeholder="กรุณาเลือก"
                      onChange={(e) => {
                        setDivisionId(e);
                      }}
                    >
                      {dropDownDivision.map((item) => (
                        <Option value={item.divisionId}>
                          {item.divisionNameTh}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={16}>
                  <Form.Item
                    label="ตัวชี้วัดยุทธศาสตร์"
                    name={"indicatorId"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ",
                      },
                    ]}
                  >
                    <Select
                      allowClear
                      style={{
                        width: "100%",
                      }}
                      placeholder="กรุณาเลือก"
                    >
                      {listIndicators.map((item) => (
                        <Option value={item.indicatorId}>
                          {item.indicatorNameTh}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={16}>
                  <Row gutter={[3, 16]}>
                    <Col span={24}>
                      <Form.Item
                        label="ผลค่าตัวชี้วัดประจำเดือน"
                        name={"monthlyIndicator"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Input placeholder="ค่าตัวชี้วัดยุทธศาสตร์ประจำเดือน" />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="คาดการณ์ ผลตัวชี้วัด ณ สิ้นไตรมาส"
                        name={"quarterlyForecast"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Input placeholder="ค่าผลคาดการณ์ผลตัวชี้วัดยุทธศาสตร์ ณ สิ้นไตรมาส" />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="คาดการณ์ ผลตัวชี้วัด ณ สิ้นปีงบประมาณ"
                        name={"annualForecast"}
                        rules={[
                          {
                            required: true,
                            message: "โปรดระบุ",
                          },
                        ]}
                      >
                        <Input placeholder="ค่าผลคาดการณ์ผลตัวชี้วัดยุทธศาสตร์ ณ สิ้นปีงบประมาณ" />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </div>

      <SuccessModal
        open={successModal}
        setOpen={setSuccessModal}
        title={"สำเร็จ"}
        subTitle={"ทำรายการสำเร็จ"}
      />
      <FailModal
        title={errorMessage ? errorMessage : ""}
        subTitle={errorMessage ? "กรุณาทำการตรวจสอบข้อมูล" : ""}
        open={failModal}
        setOpen={setFailModal}
        setErrMsg={setErrorMessage}
      />
    </WithSidebar>
  );
};
